import { CloseCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentCancel = () => {
  const navigate = useNavigate();
  console.log("Payment cancelled, redirecting to dashboard...");
  

  return (
    <div style={styles.container}>
      <CloseCircleOutlined style={styles.icon} />
      <h1 style={styles.title}>Payment cancelled!</h1>
      <p style={styles.text}>Sorry! Your Last transaction is cancelled</p>
      
      <Button type="primary" size="large" onClick={() => navigate("/dashboard")}>
        Go to Dashboard
      </Button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
  },
  icon: {
    fontSize: "64px",
    color: "red",
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  text: {
    fontSize: "16px",
    marginBottom: "20px",
  },
};

export default PaymentCancel;
